var e = {
	meta: {
		home: "Book verified vacation rentals across Egypt — North Coast chalets, El Gouna villas, and Cairo furnished apartments. Flexible payments and installments. Book on Maat Stays.",
		map: "Search stays on the map: filter by dates, guests, price and amenities, and see what is free where you want to be.",
		guides: "Travel guides written by local hosts: where to eat, what to see and the places worth the trip.",
		help: "Answers about booking, payments, cancellations and hosting on Maat Stays, and how to reach our support team.",
		helpFaq: "Frequently asked questions about booking, paying for and staying in a place on Maat Stays.",
		experiences: "Book experiences hosted by locals, from tours to classes, with sessions you can reserve by date.",
		services: "Book services from local providers: choose an option, pick a time and reserve it on Maat Stays.",
		guideDestination: {
			title: "Travel guides to {{area}}",
			description: "Travel guides to {{area}} written by local hosts: where to eat, what to see and the places worth the trip."
		},
		about: "What Maat Stays is: homes, apartments and chalets to stay in, plus experiences and services hosted by locals.",
		hostWithUs: "List your place, an experience or a service on Maat Stays, set your own prices and rules, and welcome guests.",
		terms: "The terms of service that apply when you book or host on Maat Stays.",
		privacy: "How Maat Stays collects, uses and protects your personal data."
	},
	placeholder: {
		title: "Placeholder — final copy pending",
		body: "This page is a draft. Its final wording has not been written yet, so nothing on it is final.",
		toBeProvided: "To be provided."
	},
	about: {
		title: "About Maat Stays",
		subtitle: "Stays worth the trip",
		sections: {
			whatWeDo: {
				heading: "What we do",
				body: "Maat Stays connects travellers with hosts who offer homes, apartments and chalets to stay in, along with experiences and services run by locals."
			},
			howItWorks: {
				heading: "How it works",
				body: "Search on the map or browse by destination, message the host before you book, and pay online in EGP or USD."
			},
			contact: {
				heading: "Get in touch",
				body: "For a question about a booking or your account, the Help center is the quickest way to reach us."
			}
		}
	},
	terms: {
		title: "Terms of service",
		subtitle: "The terms that will apply when you use Maat Stays.",
		sections: {
			usingMaat: "Using Maat Stays",
			accounts: "Your account",
			bookingsAndPayments: "Bookings and payments",
			cancellations: "Cancellations and refunds",
			hosting: "Hosting on Maat Stays",
			liability: "Liability",
			changes: "Changes to these terms"
		}
	},
	privacy: {
		title: "Privacy policy",
		subtitle: "How Maat Stays will handle your personal data.",
		sections: {
			whatWeCollect: "What we collect",
			howWeUseIt: "How we use it",
			whoWeShareItWith: "Who we share it with",
			howLongWeKeepIt: "How long we keep it",
			yourRights: "Your rights",
			contact: "Contacting us about privacy"
		}
	},
	hostWithUs: {
		title: "Host with Maat Stays",
		subtitle: "List your place, an experience or a service, and welcome guests on your own terms.",
		benefits: {
			reach: {
				title: "Reach travellers",
				body: "Your listing shows up in search and on the map, where guests are already looking for somewhere to stay."
			},
			control: {
				title: "Stay in control",
				body: "Set your own prices, house rules and calendar, and talk to guests before they book."
			},
			payouts: {
				title: "Get paid",
				body: "Guests pay online when they book, and your earnings are tracked in one place."
			}
		},
		cta: "Become a host"
	},
	footer: {
		support: {
			title: "Support",
			helpCenter: "Help center",
			faq: "FAQs"
		},
		hosting: {
			title: "Hosting",
			becomeHost: "Become a host"
		},
		company: {
			title: "Maat Stays",
			about: "About",
			terms: "Terms of service",
			privacy: "Privacy policy"
		}
	}
};
//#endregion
export { e as default };
